<mat-card class="main-container">
  <mat-card-header>
    <mat-card-title class="header-logo">
      <img src="/assets/images/logo.png" alt="biome-logo" />
    </mat-card-title>
    <mat-card-title>Login to continue</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (savedLoginIds$ | async; as savedLoginIds) {
      @if (savedLoginIds.length) {
        <mat-nav-list class="saved-login-list">
          @for (loginId of savedLoginIds; track loginId.username) {
            <div class="flex-container">
              <mat-list-item (click)="selectLoginId(loginId.username)">
                <mat-icon class="material-symbols-outlined" matListItemIcon
                  >account_circle</mat-icon
                >
                <span matListItemTitle class="title">{{
                  loginId.username
                }}</span>
              </mat-list-item>
              <button
                mat-icon-button
                (click)="removeLoginId(loginId.username)"
                matTooltip="Remove ID"
              >
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
              </button>
            </div>
          }
        </mat-nav-list>
        <div class="username-divider">
          <span>or enter a username</span>
        </div>
      } @else {
        <mat-card-subtitle>Enter your username here</mat-card-subtitle>
      }
      <ul class="username-guidance">
        <li class="guidance-row">
          <mat-icon class="material-symbols-outlined inline-icon"
            >domain</mat-icon
          >
          <span
            >If your hospital uses single sign-on (SSO), enter your
            <strong> hospital Cloud ID</strong>.</span
          >
        </li>
        <li class="guidance-row">
          <mat-icon class="material-symbols-outlined inline-icon"
            >alternate_email</mat-icon
          >
          <span
            >Otherwise, enter your username ending in
            <strong>&#64;biomedata.io</strong>.</span
          >
        </li>
      </ul>
    }
    <form (ngSubmit)="onSubmit()" #ngLoginForm="ngForm">
      <mat-form-field class="example-form-field" subscriptSizing="dynamic">
        <input matInput [formControl]="username" type="text" />
        @if (
          (username.touched || ngLoginForm.submitted) &&
          username.errors?.["email"]
        ) {
          <mat-error>Username must be an email.</mat-error>
        }
        @if (
          (username.touched || ngLoginForm.submitted) &&
          username.errors?.["required"]
        ) {
          <mat-error>Username is required.</mat-error>
        }
      </mat-form-field>
    </form>
    <p class="username-help">
      <mat-icon class="material-symbols-outlined inline-icon">help</mat-icon>
      <span
        >Not sure which to use?
        <a class="color-primary" [routerLink]="['/forgot-credentials']"
          >Request your username</a
        ></span
      >
    </p>
    @if (authError()) {
      <div class="auth-error">
        {{ authError() }}
      </div>
    }
    @if (passwordNotSet() && !linkRequestSent()) {
      <div class="info-panel">
        <span>You have not created a password to use with this account.</span>
        <a
          class="color-primary"
          data-ba-id="requestPasswordLink"
          (click)="!busy() && requestPasswordLink()"
        >
          Request Secure link to set password
        </a>
      </div>
    }
    @if (linkRequestSent()) {
      <div class="info-panel">
        An email with a link to set your password has been sent. Please check
        your inbox.
      </div>
    }
    @if (!passwordNotSet() || linkRequestSent()) {
      <div class="login-actions">
        <div
          class="login-button"
          [ngClass]="{
            error:
              username.invalid && (username.touched || ngLoginForm.submitted),
          }"
        >
          <button
            mat-raised-button
            data-ba-id="login"
            color="primary"
            [disabled]="busy()"
            (click)="onSubmit()"
          >
            @if (!busy()) {
              <mat-icon class="material-symbols-outlined">login</mat-icon>
            }
            <div class="login-text-container">
              @if (busy()) {
                <mat-spinner diameter="20"></mat-spinner>
              }
              @if (!busy()) {
                <span class="login-text">Continue </span>
              }
              @if (busy()) {
                <span class="login-text">Logging in...</span>
              }
            </div>
          </button>
        </div>
      </div>
    }
    <br />
    <div class="forgot-credentials color-primary">
      <a [routerLink]="['/forgot-credentials']">Forgot password or username?</a>
    </div>
  </mat-card-content>
</mat-card>
<ba-support-button />
